import { render, staticRenderFns } from "./BlockAwards.vue?vue&type=template&id=37117282"
import script from "./BlockAwards.vue?vue&type=script&lang=js"
export * from "./BlockAwards.vue?vue&type=script&lang=js"
import style0 from "./BlockAwards.vue?vue&type=style&index=0&id=37117282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports